module.exports = __webpack_public_path__ + "img/SketchPng4262dbf058d0e8890911899119c559b13875107f0e110eb598a194649e2d0980.689ca2ca.png";